import { html, css, LitElement } from 'lit'

class AutoToolTip extends LitElement {
  static get properties() {
    return {
      tooltip: { type: String },
      flow: { type: String },
      show: { type: Boolean },
    }
  }

  constructor() {
    super()
    this.tooltip = null
    this.flow = null
    this.show = false
  }

  connectedCallback() {
    super.connectedCallback()
    setTimeout(() => {
      this.show = true
    }, 1000)
    setTimeout(() => {
      this.show = false
    }, 4000)
  }

  render() {
    return html`
      <div>
        <span
          flow=${this.flow}
          tooltip=${this.show ? this.tooltip : ''}
          class=${this.show ? 'visible' : ''}
        >
          <slot></slot>
        </span>
      </div>
    `
  }
  static styles = css`
    [tooltip] {
      position: relative;
    }

    [tooltip]::before,
    [tooltip]::after {
      text-transform: none;
      font-size: 0.9em;
      line-height: 1;
      user-select: none;
      pointer-events: none;
      position: absolute;
      display: none;
      opacity: 0;
    }
    [tooltip]::before {
      content: '';
      border: 5px solid transparent;
      z-index: 1001;
    }
    [tooltip]::after {
      content: attr(tooltip);
      text-align: center;
      min-width: 3em;
      max-width: 21em;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      padding: 1ch 1.5ch;
      border-radius: 0.3ch;
      box-shadow: 0 1em 2em -0.5em rgba(0, 0, 0, 0.35);
      background: var(--kula-deep-green);
      color: var(--kula-light-green);
      z-index: 1000;
    }

    [tooltip]:not([tooltip=''])::before,
    [tooltip]:not([tooltip=''])::after {
      display: block;
      opacity: 1;
    }

    [tooltip='']::before,
    [tooltip='']::after {
      display: none !important;
    }

    [tooltip]:not([flow])::before,
    [tooltip][flow^='up']::before {
      bottom: 100%;
      border-bottom-width: 0;
      border-top-color: var(--kula-deep-green);
    }
    [tooltip]:not([flow])::after,
    [tooltip][flow^='up']::after {
      bottom: calc(100% + 5px);
    }
    [tooltip]:not([flow])::before,
    [tooltip]:not([flow])::after,
    [tooltip][flow^='up']::before,
    [tooltip][flow^='up']::after {
      left: 50%;
      transform: translate(-50%, -0.5em);
    }

    /* FLOW: DOWN */
    [tooltip][flow^='down']::before {
      top: 100%;
      border-top-width: 0;
      border-bottom-color: var(--kula-deep-green);
    }
    [tooltip][flow^='down']::after {
      top: calc(100% + 5px);
    }
    [tooltip][flow^='down']::before,
    [tooltip][flow^='down']::after {
      left: 50%;
      transform: translate(-50%, 0.5em);
    }

    /* FLOW: LEFT */
    [tooltip][flow^='left']::before {
      top: 50%;
      border-right-width: 0;
      border-left-color: var(--kula-deep-green);
      left: calc(0em - 5px);
      transform: translate(-0.5em, -50%);
    }
    [tooltip][flow^='left']::after {
      top: 50%;
      right: calc(100% + 5px);
      transform: translate(-0.5em, -50%);
    }

    /* FLOW: RIGHT */
    [tooltip][flow^='right']::before {
      top: 50%;
      border-left-width: 0;
      border-right-color: var(--kula-deep-green);
      right: calc(0em - 5px);
      transform: translate(0.5em, -50%);
    }
    [tooltip][flow^='right']::after {
      top: 50%;
      left: calc(100% + 5px);
      transform: translate(0.5em, -50%);
    }

    @keyframes tooltips-vert {
      to {
        opacity: 0.9;
        transform: translate(-50%, 0);
      }
    }

    @keyframes tooltips-horz {
      to {
        opacity: 0.9;
        transform: translate(0, -50%);
      }
    }

    [tooltip].visible:not([flow])::before,
    [tooltip].visible:not([flow])::after,
    [tooltip].visible[flow^='up']::before,
    [tooltip].visible[flow^='up']::after,
    [tooltip].visible[flow^='down']::before,
    [tooltip].visible[flow^='down']::after {
      animation: tooltips-vert 300ms ease-out forwards;
    }
    [tooltip].visible[flow^='left']::before,
    [tooltip].visible[flow^='left']::after,
    [tooltip].visible[flow^='right']::before,
    [tooltip].visible[flow^='right']::after {
      animation: tooltips-horz 300ms ease-out forwards;
    }
  `
}

customElements.define('auto-tool-tip', AutoToolTip)
export default AutoToolTip
